import { useMutation, useQueryClient } from '@tanstack/react-query';
import { refreshBotAccess } from '../../../services/bot-access/BotAccessService';
import { GET_BOT_ACCESS } from '../../query/bot-access/keys';

export const useRefreshBotAccess = (projectId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => refreshBotAccess(projectId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_BOT_ACCESS, projectId] });
    },
  });
};
